import { encryptSSNFields } from "./hashSSN";

/**
 * Encrypt SSN-related fields in FormData using the given password.
 *
 * @param formData - The original FormData object
 * @param password - The encryption password
 * @returns A new FormData instance with encrypted values
 */
async function handleFormDataEncryption(formData: FormData, password: string): Promise<FormData> {
	const encryptedFormData = new FormData();

	for (const [key, value] of Array.from(formData.entries())) {
		// Attempt to parse as JSON
		let parsedValue;

		try {
			parsedValue = JSON.parse(value as string); // may throw
		} catch (e) {
			parsedValue = null;
		}

		// If it's JSON and contains SSN-like fields, encrypt
		if (parsedValue && typeof parsedValue === "object") {
			const encrypted = await encryptSSNFields(parsedValue, password);
			encryptedFormData.append(key, JSON.stringify(encrypted));
		} else {
			// If not JSON or no SSNs to encrypt, just append as-is
			encryptedFormData.append(key, value);
		}
	}

	return encryptedFormData;
}

export default handleFormDataEncryption;
